"use client";

import { Button } from "@/components";
import { getImageURL, sanitizeHTML } from "@/lib";

export const HomePageProductHighlights = ({
    data = {},
    slug = "product_categories",
}) => {
    const {
        heading = "",
        list = [],
        main_image,
        second_image,
        description,
        cta,
        product_stats = [],
    } = data;

    if (!Array.isArray(product_stats) || product_stats.length === 0) {
        return null;
    }

    return (
        <>
            <section className="product_highlights_section">
                <div className="custom-container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-12 col-xl-12">
                            <div className="section_header text-left">
                                <h4
                                    className="heading fs-48 fw-300"
                                    dangerouslySetInnerHTML={{
                                        __html: sanitizeHTML(heading),
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex product_highlight_box">
                        <div className="col-12 col-lg-5 col-xl-5">
                            <div className="product_highlight_left_box">
                                <div className="product_highlight_img">
                                    {main_image?.src && (
                                        <img
                                            src={getImageURL(main_image?.src)}
                                            alt={main_image?.alt || ""}
                                            srcSet=""
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-7 col-xl-7">
                            <div className="product_highlight_top">
                                <div className="product_highlight_list">
                                    <ul className="d-flex">
                                        {product_stats.map((stat, idx) => (
                                            <li key={idx}>
                                                <div className="product_highlight_list_img">
                                                    {stat.icon?.src && (
                                                        <img
                                                            src={getImageURL(
                                                                stat.icon.src
                                                            )}
                                                            alt={
                                                                stat.icon
                                                                    ?.alt || ""
                                                            }
                                                            srcSet=""
                                                        />
                                                    )}
                                                </div>
                                                <div className="fs-16 product_highlight_list_content">
                                                    <h3
                                                        className="fs-20"
                                                        dangerouslySetInnerHTML={{
                                                            __html: sanitizeHTML(stat?.number),
                                                        }}
                                                    />

                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: sanitizeHTML(stat?.description),
                                                        }}
                                                    />
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="product_highlight_bottom">
                                <div className="product_highlight_bottom_box">
                                    <div className="product_highlight_img">
                                        {second_image?.src && (
                                            <img
                                                src={getImageURL(
                                                    second_image?.src
                                                )}
                                                alt={second_image?.alt || ""}
                                                srcSet=""
                                            />
                                        )}
                                    </div>
                                    <div className="product_highlight_contnet">
                                        <p
                                            dangerouslySetInnerHTML={{
                                                __html: sanitizeHTML(description),
                                            }}
                                        />

                                        <div className="module__footer">
                                            <div className="btn-group">
                                                {cta?.title && (
                                                    <Button
                                                        label={cta.title}
                                                        href={cta.url}
                                                        target={
                                                            cta.open_new_tab ===
                                                            "yes"
                                                                ? "_blank"
                                                                : undefined
                                                        }
                                                    />
                                                )}
                                                {Array.isArray(list) &&
                                                    list.map((item, idx) => (
                                                        <a
                                                            key={idx}
                                                            className="primary_text_btn"
                                                            href={
                                                                item.link
                                                                    ?.url || "#"
                                                            }
                                                            target={
                                                                item.link
                                                                    ?.open_new_tab ===
                                                                "yes"
                                                                    ? "_blank"
                                                                    : undefined
                                                            }
                                                            rel={
                                                                item.link
                                                                    ?.open_new_tab ===
                                                                "yes"
                                                                    ? "noopener noreferrer"
                                                                    : undefined
                                                            }
                                                        >
                                                            <span className="btn_text">
                                                                {item.title}
                                                            </span>
                                                        </a>
                                                    ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
